function FirstRef() {
  return (
    <div>
      <li className="bullet-item">The year initial: first time that the association was reported</li>
    </div>
  );
}

export default FirstRef;
